import Navbar from "./components/Navbar";
import Home from "./components/Home";
import SocialLinks from "./components/SocialLinks";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Experience from "./components/Experience";
import Certificate from "./components/Certificate";
import Contact from "./components/Contact";

function App() {
  return (
   <>
    <Navbar />
    <Home />
    <SocialLinks />
    <About />
    <Portfolio />
    <Experience />
    <Certificate />
    <Contact />
   </>
  );
}

export default App;
